import store from 'store'
import SendBird from 'sendbird'
import axios from 'axios'
import {getMessengerClient} from '../../utils/messenger'

export const CONNECT_REQUEST = 'CONNECT_REQUEST'
export const CONNECT_SUCCESS = 'CONNECT_SUCCESS'
export const CONNECT_FAILURE = 'CONNECT_FAILURE'

function connectRequest () {
  return {
    type: CONNECT_REQUEST
  }
}
function connectSuccess (user) {
  return {
    type: CONNECT_SUCCESS,
    user
  }
}
function connectFailure (error) {
  return {
    type: CONNECT_FAILURE,
    error
  }
}

export function connect (appId, user) {
  return async (dispatch, getState) => {
    const client = new SendBird({appId: appId})

    dispatch(connectRequest())

    // console.log('----> THIS INFORMATION IS ONLY TO BE TESTED BY QA: ', user.id, user.sessionToken);
    // window.sc = client

    client.connect(user.id, user.sessionToken, (userMessenger, error) => {
      if (error) {
        // Messenger Session Token expired.
        if (error && error.code === 400302) {
          dispatch(refreshSessionToken(appId, user))
          return null
        }

        dispatch(postConnectionFailure(error))
        return false
      }

      dispatch(postConnectionSuccess(userMessenger, user))
    })
  }
}

export function updateCurrentUserInfo (user) {
  return async (dispatch, getState) => {
    const sb = getMessengerClient()

    if (typeof sb !== 'undefined' && typeof sb.updateCurrentUserInfo === 'function') {
      sb.updateCurrentUserInfo(
        user.nickname,
        user.profilePicture,
        (response, error) => {
          if (error) {
            console.error(error)
            return false
          }
        }
      )
    }
  }
}

function refreshSessionToken (appId, user) {
  return async dispatch => {
    console.log('Messenger Session Token Expired. Getting a new one...')

    const client = new SendBird({appId: appId})
    let sessionToken = null

    try {
      sessionToken = await getRefreshedMessengerSessionToken()
    } catch (exception) {
      dispatch(postConnectionFailure(exception))
      return false
    }

    client.connect(user.id, sessionToken, (userMessenger, error) => {
      if (error) {
        dispatch(postConnectionFailure(error))
        return false
      }

      console.log('Messenger Session Token Refreshed successfully!')
      dispatch(postConnectionSuccess(userMessenger, user))
      return true
    })
  }
}

function postConnectionSuccess (userMessenger, user) {
  return async dispatch => {
    dispatch(connectSuccess(userMessenger))
    store.set('user', userMessenger)
    dispatch(updateCurrentUserInfo(user))
  }
}

function postConnectionFailure (exception) {
  return async dispatch => {
    dispatch(connectFailure(exception))
    console.error('The connection to Messenger was not possible.')
    return false
  }
}

async function getRefreshedMessengerSessionToken () {
  try {
    const response = await axios.get('/account/messenger/refresh')

    return response.data.sessionToken
  } catch (e) {
    console.error(e)
    throw e
  }
}
